module.exports = __webpack_public_path__ + "static/media/b-sci-major-35_LR.4ffa7cd4.jpg";